import {Pipe, PipeTransform} from '@angular/core';
import {transformCamelCaseStringSeparated} from '../../utils/string/string.utils';

/**
 * A pipe that transforms a camelCase string into a string with spaces inserted before uppercase letters.
 * Additionally, it capitalizes the first letter of the resulting string.
 * Example:
 *   "camelCaseString" -> "Camel Case String"
 *
 * @example
 *  {{ 'camelCaseStringExample' | camelCaseToSeparated }}
 *  // Output: "Camel Case String Example"
 */
@Pipe({
    name: 'gallixCamelCaseToSeparated',
    standalone: false
})
export class GallixCamelCaseToSeparatedPipe implements PipeTransform {

  /**
   * Transforms a camelCase string into a string with spaces before uppercase letters.
   * Also capitalizes the first letter of the transformed string.
   *
   * @param value The input string in camelCase format.
   * @returns A string with spaces inserted before uppercase letters and the first letter capitalized.
   */
  transform(value: string): string {
    if (!value) return value;
    return transformCamelCaseStringSeparated(value);
  }

}
